import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { PetListComponent } from '@feature/pet-list/pet-list.component';
import { PetDetailComponent } from '@feature/pet-detail/pet-detail.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', redirectTo: 'all', pathMatch: 'full' },
      {
        path: ':category',
        children: [
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          {
            path: 'list',
            component: PetListComponent,
          },
          {
            path: 'detail/:id',
            component: PetDetailComponent,
          },
        ],
      },
    ],
  },
];
